<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <h3 class="mb-2">Prestações</h3>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <div v-if="lista.length" class="table-responsive">
                                    <b-table
                                        id="boletos" 
                                        :fields="colunas" 
                                        :items="lista" 
                                        :per-page="porPagina"
                                        sticky-header 
                                        head-variant="dark" 
                                        striped 
                                        hover
                                        selectable 
                                        :select-mode="selectMode"
                                        @row-selected="selecionar"
                                        @sort-changed="definirOrdem"
                                        :sort-by="ordem"
                                        :sort-desc="tp_ordem"
                                        style="max-height: 600px"
                                        :tbody-tr-class="obterClassePorStatus"
                                    >
                                        <template #cell(link_boleto)="{ item }">
                                            <template v-if="item.link_boleto">
                                                <a target="_blank" :href="item.link_boleto" class="btn btn-info btn-outline text-white" v-b-tooltip.hover title="Link Boleto" :disabled="item.status == 'CANCELADO'">                                                    
                                                    <b-icon-file-earmark-arrow-down font-scale="2"></b-icon-file-earmark-arrow-down>
                                                </a>
                                            </template>
                                        </template>
                                        <template #cell(status_descricao)="{ item }">
                                            <span class="badge badge-default">{{ item.status_descricao }}</span>
                                        </template>
                                    </b-table>
                                </div>
                                <div v-else>
                                    <p>Nenhum registro encontrado.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div v-if="lista.length" class="row">
                            <div class="col-12">
                                <b-pagination
                                    v-model="paginaAtual" 
                                    :total-rows="total" 
                                    :per-page="porPagina" 
                                    aria-controls="boletos"
                                    @change="obterLista"
                                ></b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

import api from '@/api/app.api.js';

import Util from '@/util.js';

export default {
    components: {
    },
    props: {
        modelId: {
            type: Number,
            required: true
        },
        tipo: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            colunas: [
                {
                    key: 'valor',
                    label: 'Valor',
                    sortable: true,
                    formatter: this.formatarDinheiro
                },
                {
                    key: 'vl_pago',
                    label: 'Valor Pago',
                    sortable: true,
                    formatter: this.formatarDinheiro
                },
                {
                    key: 'nu_parcela',
                    label: 'Prestação',
                    sortable: true
                },
                {
                    key: 'dt_vencimento',
                    label: 'Data de Vencimento',
                    sortable: true,
                    formatter: this.converterDataUsParaBr
                },
                {
                    key: 'dt_pagamento',
                    label: 'Data de Pagamento',
                    sortable: true
                },
                {
                    key: 'link_boleto',
                    label: 'Link do Boleto',
                    sortable: true
                },
                {
                    key: 'status_descricao',
                    label: 'Status',
                    sortable: true
                }
            ],
            lista: [],
            selectMode: 'single',
            selecionados: [],
            paginaAtual: 0,
            total: 1,
            porPagina: 10,
            ordem: 'nu_parcela',
            tp_ordem: false,
            msgConfirmarAcao: 'Tem certeza que deseja realizar esta operação?',
            modalSegundaViaBoletoShow: false,
            modalInformarPagametoShow: false
        };
    },
    mounted() {
        this.obterLista(0);
    },
    methods: {
        ...mapActions('msgErro', { exibirMsgErro: 'exibirMsgErro' }),
        ...mapActions('msgSucesso', { exibirMsgSucesso: 'exibirMsgSucesso' }),
        definirOrdem(e) {
            this.ordem = e.sortBy;
            this.tp_ordem = e.sortDesc;
            this.obterLista(0);
            this.paginaAtual = 0;
        },
        selecionar(itens) {
            this.selecionados = itens;
        },
        obterLista(paginaAtual) {
            const pag = ((paginaAtual !== undefined ? paginaAtual : this.paginaAtual) - 1);

            const dados = {
                offset: pag < 0 ? 0 : pag,
                limit: this.porPagina,
                ordem: this.ordem,
                tp_ordem: this.tp_ordem ? 'DESC' : 'ASC',
                compraId: this.tipo === 'compra' ? this.modelId : null,
                taxaId: this.tipo === 'taxa' ? this.modelId : null
            };

            if (this.tipo === 'compra')
            {
                api.listarBoletosPorCompra(dados).then(res => {
                    this.lista = res.data.data;
                    this.total = res.data.total;
                });
            } else  {
                api.listarBoletosPorTaxa(dados).then(res => {
                    this.lista = res.data.data;
                    this.total = res.data.total;
                })
            }

            this.paginaAtual = pag;
        },
        obterClassePorStatus(item, type) {
            if (item && type === 'row') {
                const status = item.status;

                if (status === 'ABERTO') {
                    return 'bg-warning';
                } else if (status === 'PAGO') {
                    return 'bg-success';
                } else if (status === 'CANCELADO') {
                    return 'bg-danger';
                }
            }
        },
        formatarDinheiro(valor) {
            if (!valor) {
                return null;
            }
            return Util.formatarDinheiro(valor);
        },
        converterDataUsParaBr(data) {
            return Util.converterDataUsParaBr(data);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/Contrato/Components/Financiamento/Prestacoes.vue